import { LitElement, html, css } from 'lit';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import { Liquid } from 'liquidjs';

class DplLiquidComponent extends LitElement {
    static properties = {
        data: { type: String },
        queries: { type: Object, converter: {
                fromAttribute: (value, type) => {
                    if (typeof value === 'object')
                        return value;
                    return JSON.parse(value.replaceAll("'", '"'));
                },
                toAttribute: (value, type) => {
                    console.log('toAttribute:', value, type)
                    if (typeof value === 'object')
                        return value;
                    return JSON.stringify(value);
                }
            }
        },
        templateContent: { state: true },
        isLoading: { state: true }
    };

    _data = {};
    _model = {};
    _parsedTemplate = null;
    set data(value) {
        console.log(`data[${typeof value}]:`, value);
        if (value === this._data)
            return;
        try {
            this._data = JSON.parse(value.replaceAll("'", '"'));
            console.log('data is json. value=', this._data)
        }catch (error) {
            this._data = value;
            console.log('data is not json. value=', this._data)
        }
        if(this._setupComplete)
            this.updateTemplate();
    }
    get data() {
        return this._data;
    }

    constructor() {
        super();
        this.queries = {};
        this.templateContent = '';
        this.isLoading = true;
    }

    async firstUpdated() {
        const slot = this.shadowRoot.querySelector('slot');
        slot.assignedNodes({flatten: true});

        const nodes = slot.assignedNodes({flatten: true});

        await this.updateTemplate();
        this._setupComplete = true;
    }

    _scripts = [];
    _lastTemplate = '---';
    async updateTemplate() {
        this.isLoading = true;

        const {template, scripts} = this.getSlotContent();
        this._scripts = scripts;
        if (template !== this._lastTemplate) {
            this._lastTemplate = template;
            if (!this._engine)
                this._engine = new Liquid();
            try {
                //this.templateContent = await this._engine.parse(template, {data: this._data, ...await this.queryResults()});
                this._parsedTemplate = this._engine.parse(template);
            } catch (error) {
                console.error('Error rendering template:', error);
            }
        }

        this._model = {data: this._data, ...await this.queryResults()};
        this.templateContent = await this._engine.render(
            this._parsedTemplate,
            this._model
        );
        this.isLoading = false;
    }

    getSlotContent() {
        const slot = this.shadowRoot.querySelector('slot');
        const nodes = slot.assignedNodes({flatten: true});
        let template = '';
        let scripts = []
        return extractHtml(nodes, template, scripts);
    }

    static styles = css`
        :host {
            display: block;
            transition: opacity 0.3s ease;
            opacity: 1;
        }
        :host([isLoading]) {
            opacity: 0.5;
        }
        slot {
            display: none;
        }
    `;

    render() {
        return html`
                    <slot @slotchange="${this.updateTemplate}"></slot>
                    ${unsafeHTML(this.templateContent)}
                `;
    }

    updated(changedProperties) {
        super.updated(changedProperties);
        if (this._scripts.length > 0)
            setTimeout(this.runScripts, 300)
    }
    runScripts = () => {
        const dataJson = JSON.stringify(this._model);
        for (const s of this._scripts) {
            eval(`const data = ${dataJson};
${s}`);
        }
    }
    async queryResults() {
        const promises = [];
        const results = {}
        for (const [key, value] of Object.entries(this.queries)) {
            if (value) {
                promises.push(new Promise(async (resolve, reject) => {
                    results[key] = await this.query(value);
                    resolve();
                }));
            }
        }
        await Promise.all(promises);
        return results;
    }
    async query(query) {
        const request = await fetch(query);
        if (!request.ok) {
            console.error('Error fetching query:', request);
            return 'Error fetching query';
        }
        try {
            return await request.json();
        } catch (error) {
            console.error('Error parsing query response:', error);
            return 'Error parsing query response';
        }
    }
}

customElements.define('dpl-liquid', DplLiquidComponent);
function extractHtml(nodes, template, scripts) {
    for(const n of nodes) {
        switch (n.nodeType) {
            case Node.TEXT_NODE:
                template += n.data;
                break;
            case Node.ELEMENT_NODE:
                switch (n.tagName) {
                    case 'SCRIPT':
                        scripts.push(n.innerHTML);
                        continue;
                    case 'TEMPLATE':
                        const ret= extractHtml(n.content.childNodes, template, scripts);
                        template += ret.template;
                        scripts = ret.scripts;
                        continue;
                    default:
                        template += n.outerHTML;
                }
                break;
            default:
                console.log(`n[${n.nodeType}]: innerHTML=${n.innerHTML} data=${n.data} textContent=${n.textContent} outerHTML=${n.outerHTML}`);
        }
    }
    return {template, scripts}
}